var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossArrowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#727176"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.91 18.833H16.724l3.592-3.841a1.225 1.225 0 0 0 0-1.65 1.041 1.041 0 0 0-1.543 0l-5.455 5.833a1.225 1.225 0 0 0 0 1.65l5.455 5.833c.213.228.492.342.771.342.28 0 .559-.114.772-.342a1.224 1.224 0 0 0 0-1.65l-3.592-3.841h19.184c.603 0 1.091-.523 1.091-1.167s-.488-1.167-1.09-1.167Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.226 23.342a1.041 1.041 0 0 0-1.543 0 1.225 1.225 0 0 0 0 1.65l3.592 3.841H14.091c-.603 0-1.091.523-1.091 1.167s.488 1.167 1.09 1.167h19.185l-3.592 3.841a1.225 1.225 0 0 0 0 1.65c.213.228.492.342.772.342.279 0 .558-.114.77-.342l5.456-5.833a1.225 1.225 0 0 0 0-1.65l-5.455-5.833Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossArrowsIcon);
export default __webpack_public_path__ + "static/media/cross_arrows_icon.803ee658ad93b0ecad570997e5db2be6.svg";
export { ForwardRef as ReactComponent };